import { get } from "../../api";

const serviceNavListData = (headers, isSSRCall) =>
  get("desktopHeader", headers, null, isSSRCall);
const serviceNavListMDataMobile = () => {};

export { serviceNavListData, serviceNavListMDataMobile };
